<template>
  <div class="h100vh-140">
    <div class="h-wrapper-680">
      <div class="h-dialogContainer">
        <form id="accountForm">
          <div class="row h-row-inputBox">
            <div class="form-group h-col-inputBox">
              <div class="e-float-input">
                <div class="h-inputLit">{{$t('Security.Strategy.accountMinNumber')}}:</div>
                <div class="e-input-group e-control-wrapper">
                  <input class="e-control e-textbox e-lib e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="accountByte" name="AccountByte" v-model="accountByte" />
                </div>
              </div>
            </div>
          </div>
          <ejs-checkbox :label="$t('Security.Strategy.accountLock')" ref="accountLocking" :checked="true" :change="setStates"></ejs-checkbox>
          <div class="row h-row-inputBox">
            <div class="h-col-inputBox">
              <div class="h-borderBox h-blueBg">
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <!-- <div class="e-float-input"> -->
                    <div class="h-inputLit">{{$t('Security.Strategy.lockPeriod')}}</div>
                    <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="pointTime" name="PointTime" v-model="pointTime" :disabled="readonly" />
                    <!-- </div> -->
                  </div>
                </div>
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <div class="h-inputLit">{{$t('Security.Strategy.failTimes')}}</div>
                    <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="pointTimeFailure" name="PointTimeFailure" v-model="pointTimeFailure" :disabled="readonly" />
                  </div>
                </div>
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <ejs-radiobutton class="h-inputLit" ref="lockingTimeRadio" :label="$t('Security.Strategy.lockTime')" name="LockingTimeRadio" :disabled="readonly" :change="setRadioState" :checked="lockingTimeRadio"></ejs-radiobutton>
                    <input class="e-input" :placeholder="$t('Security.placeholder.inputInteger')" id="lockingTime" name="LockingTime" v-model="lockingTime" :disabled="readonly" />
                  </div>
                </div>
                <div class="row h-row-insertBox">
                  <div class="h-col-insertBox">
                    <ejs-radiobutton class="h-inputLit" :label="$t('Security.Strategy.lockOn')" name="LockingTimeRadio" :disabled="readonly" :change="setRadioState" :checked="!lockingTimeRadio"></ejs-radiobutton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="">{{$t('Security.Strategy.updTipInfo')}}</div>
    </div>
    <div class="b-t"></div>
    <div class="h-scroll h-system-wrapper-680">
      <div class="h-bottom-btnBox h-system-btnBox" style="margin: -10px -120px;">
        <div class="row">
          <div class="col-sm-12 h-col-inputBox">
            <ejs-button cssClass="e-control e-btn e-lib e-primary e-flat" @click.native="save">{{$t('Common.save')}}</ejs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../../../mixin/mixin'
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "accountStrategy",
  mixins: [mixin],
  data() {
    return {
      readonly: false,
      accountByte: "",
      pointTime: "",
      pointTimeFailure: "",
      lockingTime: "",
      inputNames: ['AccountByte', 'PointTime', 'PointTimeFailure', 'LockingTime'],
      rules: {
        AccountByte: { required: true, number: true, min: 1, max: 10, regex: 'integer' },
        PointTime: { required: true, number: true, min: 5, max: 1440, regex: 'integer' },
        PointTimeFailure: { required: true, number: true, min: 1, maxLength: 3, regex: 'integer' },
        LockingTime: { required: true, number: true, min: 1, max: 1440, regex: 'integer' }
      },
      formObj: "",
      lockingTimeRadio: true,
      strategyId: '',
      strategyType: 0
    };
  },
  methods: {
    setStates() {
      let checked = this.$refs.accountLocking.ej2Instances.checked;
      this.readonly = !checked;
      this.$nextTick(() => {
        this.setRadioState();
        this.formObj = this.validateForm('accountForm', this.inputNames, this.rules);
        this.$refs.accountLocking.ej2Instances.refresh();
      });
    },
    save() {
      const formStatus = this.formObj.validate();
      if (!formStatus) {
        return null;
      }
      const url = "/lte/ems/strategy/editStrategy";
      const items = {};
      items['acc.minLength'] = this.accountByte;
      if (this.$refs.accountLocking.ej2Instances.checked) {
        items['acc.lockFlag'] = '1';
        items['acc.limitTime'] = this.pointTime;
        items['acc.failCount'] = this.pointTimeFailure;
        if (this.$refs.lockingTimeRadio.ej2Instances.checked) {
          items['acc.lockType'] = '1';
          items['acc.lockTime'] = this.lockingTime;
        } else {
          items['acc.lockType'] = '0';
        }
      } else {
        items['acc.lockFlag'] = '0';
      }
      const params = {
        strategyType: this.strategyType,
        strategyId: this.strategyId,
        items: items
      };
      let That = this;
      this.axios.post(url, params).then(response => {
        const result = response.data;
        if (result) {
          That.eventEmit('success', `${this.$t("Common.tips.success")}`);
        } else {
          That.eventEmit('error', `${this.$t("Common.tips.failure")}`);
        }
        this.getAccountStrategy();
      });
    },
    setRadioState() {
      if (!this.readonly) {
        let checked = this.$refs.lockingTimeRadio.ej2Instances.checked;
        document.getElementById("lockingTime").disabled = !checked;
        this.formObj = this.validateForm('accountForm', this.inputNames, this.rules);
      }
    },
    getAccountStrategy() {
      const url = "/lte/ems/strategy/findAccountStrategy";
      this.axios.get(url).then(response => {
        this.strategyId = response.data.strategyId;
        this.strategyType = response.data.strategyType;
        const result = response.data.items;
        this.accountByte = result["acc.minLength"];
        this.pointTime = result["acc.limitTime"];
        this.pointTimeFailure = result["acc.failCount"];
        this.lockingTime = result["acc.lockTime"];
        if (result["acc.lockFlag"] === "1") {
          this.$refs.accountLocking.ej2Instances.checked = true;
        } else {
          this.$refs.accountLocking.ej2Instances.checked = false;
        }
        if (result["acc.lockType"] === "1") {
          this.lockingTimeRadio = true;
        } else {
          this.lockingTimeRadio = false;
        }
        this.setStates();
      });
    },
    eventEmit(type, content) {
      EventBus.$emit('toast', {type: type, content: content})
    }
  },
  mounted() {
    this.getAccountStrategy();
  }
};
</script>
